import { useLocation } from 'react-router-dom';

const useFamilyCTA = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('cta') === 'family';
};

export default useFamilyCTA;
